import asset from '../en-GB/asset.json';
import asset_event from '../en-GB/asset_event.json';
import asset_model from '../en-GB/asset_model.json';
import asset_type from '../en-GB/asset_type.json';
import attachment from '../en-GB/attachment.json';
import barcode from '../en-GB/barcode.json';
import batch from '../en-GB/batch.json';
import batch_compare from '../en-GB/batch_compare.json';
import batch_insight from '../en-GB/batch_insight.json';
import batch_layout from '../en-GB/batch_layout.json';
import batch_observation from '../en-GB/batch_observation.json';
import batch_phase from '../en-GB/batch_phase.json';
import category from '../en-GB/category.json';
import comment from '../en-GB/comment.json';
import common from '../en-GB/common.json';
import crop_scan from '../en-GB/crop_scan.json';
import dashboard from '../en-GB/dashboard.json';
import dashboard_item from '../en-GB/dashboard_item.json';
import dashboard_template from '../en-GB/dashboard_template.json';
import insight from '../en-GB/insight.json';
import insight_template from '../en-GB/insight_template.json';
import facility from '../en-GB/facility.json';
import location from '../en-GB/location.json';
import measurement_type from '../en-GB/measurement_type.json';
import metric from '../en-GB/metric.json';
import navigation from '../en-GB/navigation.json';
import notification from '../en-GB/notification.json';
import notification_trigger from '../en-GB/notification_trigger.json';
import organisation from '../en-GB/organisation.json';
import part from '../en-GB/part.json';
import part_type from '../en-GB/part_type.json';
import section from '../en-GB/section.json';
import team from '../en-GB/team.json';
import time from '../en-GB/time.json';
import user from '../en-GB/user.json';
import visualisation from '../en-GB/visualisation.json';
import vendor from '../en-GB/vendor.json';
import vendor_type from '../en-GB/vendor_type.json';
import shared from '../en-GB/shared.json';
import work_order from '../en-GB/work_order.json';
import work_order_request from '../en-GB/work_order_request.json';
import global from '../en-GB/global.json';
import file_manager from '../en-GB/file_manager.json';
import recyclebin from '../en-GB/recyclebin.json';
import batch_form from '../en-GB/batch_form.json';

const resources = {
  asset,
  asset_event,
  asset_model,
  asset_type,
  attachment,
  barcode,
  batch,
  batch_compare,
  batch_form,
  batch_insight,
  batch_layout,
  batch_observation,
  batch_phase,
  category,
  comment,
  common,
  crop_scan,
  dashboard,
  dashboard_item,
  dashboard_template,
  insight,
  location,
  insight_template,
  facility,
  file_manager,
  global,
  measurement_type,
  metric,
  navigation,
  notification,
  notification_trigger,
  organisation,
  part,
  part_type,
  recyclebin,
  section,
  team,
  time,
  user,
  vendor,
  shared,
  vendor_type,
  visualisation,
  work_order,
  work_order_request,
} as const;

export default resources;
